import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Utility, breadcrumbItem } from '../core/common';
import { cachedObservable } from '../core/cached-observable';
import { SharedService } from './shared.service';
import { firstValueFrom } from 'rxjs';



export type bucketItem = { Key: string; DocCount: number; };
export type resourceSearchResult = { resources: any[]; total: number; aggs?: any };

@Injectable({
  providedIn: 'root'
})
export class ResourceService {
  static resourceTypes = ['exam','course', 'education', 'template', 'guide', 'questioner', 'article', 'book', 'software', 'podcast'];
  constructor(private http: HttpClient, private sharedService: SharedService) { }


  getMetaDescription(params: { type?: string; tag?: string; q?: string; }): string {
    let desc = params.type
      ? <string>this.sharedService.getReadable(params.type, 'resourceTypeIntro')
      : 'دانلود فایل‌ها، منابع و مستندات مورد نیاز';
    if (params.tag) desc += ` #${params.tag}`;
    if (params.q) desc += ` ${params.q}`;
    return desc;
  }
  getTitle(params: { type?: string; tag?: string; q?: string; }): string {
    let title = params.type
      ? <string>this.sharedService.getReadable(params.type, 'resourceType')
      : 'منابع ارتقای شغلی';
    if (params.tag) title += ` - جستجوی «#${params.tag}»`;
    if (params.q) title += ` - جستجوی «${params.q}»`;
    return title;
  }
  getBreadcrumb(payload: { type?: string, tag?: string, q?: string }): breadcrumbItem[] {

    var items: breadcrumbItem[] = [{ title: 'منابع ارتقای شغلی', link: ['/resource'] }];

    if (payload.type)
      items.push({ title: <string>this.sharedService.getReadable(payload.type, 'resourceType'), link: ['/resource', payload.type] })
    if (payload.tag)
      items.push({ title: `#${payload.tag}`, link: ['/resource', payload.type, { tag: payload.tag }].filter(_ => _) })
    if (payload.q)
      items.push({
        title: `جستجوی "${payload.q}"`, link: ['/resource', payload.type, Utility.removeEmpty({
          tag: payload.tag,
          q: payload.q
        })].filter(_ => _)
      })

    return items;

  }

  private sources$ = cachedObservable<bucketItem[]>(this.http, 'resource', 'sources', environment.app.apiUrl + `resource/sources`, this.sharedService.log);
  getSources(all = false) {
    return all
      ? firstValueFrom(this.http.post<bucketItem[]>(environment.app.apiUrl + 'resource/sources?all=true', null))
      : firstValueFrom(this.sources$);
  }

  private tags$ = cachedObservable<bucketItem[]>(this.http, 'resource', 'tags', environment.app.apiUrl + `resource/tags`, this.sharedService.log);
  getTags(all = false) {
    return all
      ? firstValueFrom(this.http.post<bucketItem[]>(environment.app.apiUrl + 'resource/tags?all=true', null))
      : firstValueFrom(this.tags$);
  }

  private types$ = cachedObservable<bucketItem[]>(this.http, 'resource', 'types', environment.app.apiUrl + `resource/types`, this.sharedService.log);
  getTypes(all = false) {
    return all
      ? firstValueFrom(this.http.post<bucketItem[]>(environment.app.apiUrl + 'resource/types?all=true', null))
      : firstValueFrom(this.types$);
  }

  async search(criteria?: any, from = 0, limit = 20, usePost = false) {
    return usePost
      ? this.http.post<resourceSearchResult>(environment.app.apiUrl + 'resource/search', null, { params: { criteria: JSON.stringify(criteria), from, limit } }).toPromise()
      : this.http.get<resourceSearchResult>(environment.app.apiUrl + 'resource/search', { params: { criteria: JSON.stringify(criteria), from, limit } }).toPromise();
  }

  async impression(id: string, type: string) {
    return this.http.post(environment.app.apiUrl + 'resource/impression/' + id + '/' + type, null).toPromise();
  }

  // operator
  async save(resource: any, image?: Blob, ...attachments: Blob[]) {
    const body = this.addAttachments(attachments);
    body.append('resource', JSON.stringify(resource));
    if (image) body.append('image', image);
    return this.http.post<any>(environment.app.apiUrl + 'resource/save', body).toPromise();
  }

  private addAttachments(attachment: Blob[]) {
    const body = new FormData();
    for (let i = 0; i < attachment?.length; i++)
      body.append(`attachment_${i}`, attachment[i]);
    return body;
  }
  bulkUpdate(ids: any[], update: any) {
    return firstValueFrom(this.http.post<any[]>(environment.app.apiUrl + 'resource/bulk-update', { ids, update }));
  }

  get(id: string) { return this.http.get(environment.app.apiUrl + 'resource/' + id).toPromise(); }

  async pay(id: string) {
    const redirect: any = await this.http.get(environment.app.apiUrl + 'resource/pay/' + id).toPromise();
    location.href = redirect.link;
  }

  download(attachmentId: string) {
    return this.http.get(environment.app.apiUrl + `resource/download/${attachmentId}`, { responseType: 'blob' }).toPromise();
  }

  reindex(urls: string[]) {
    return this.http.post(environment.app.apiUrl + `resource/reindex`, urls).toPromise();
  }
  getPromotedService(key: string) {
    return this.http.get<any>(`assets/resources/promoted/${key}.json`).toPromise();
  }
}
